import { oc } from '@orpc/contract';
import { boolean, custom, object, string } from 'valibot';
import { CreateNewUserSchema, GetAllUsersResponseSchema, OnboardUserSchema, getScheduledEventNotificationsResponseSchema, registerPushTokenResponseSchema, } from './dtos.js';
// Helper to enforce the Database Row type if you don't have a full Schema for it yet
const ProfileSchema = custom((input) => typeof input === 'object' && input !== null);
export const contract = {
    getPaymentsLink: oc.output(object({
        url: string(),
    })),
    completeOnboarding: oc.input(OnboardUserSchema).output(object({
        success: boolean(),
    })),
    onboardUser: oc.input(CreateNewUserSchema).output(object({
        success: boolean(),
    })),
    getAllUser: oc.output(GetAllUsersResponseSchema),
    getScheduledEventNotifications: oc.output(getScheduledEventNotificationsResponseSchema),
    registerPushToken: oc.input(registerPushTokenResponseSchema).output(object({
        success: boolean(),
    })),
    resolveTradingViewSnpashotUrl: oc
        .input(object({ url: string() }))
        .output(object({ url: string() })),
};
//# sourceMappingURL=contract.js.map